import actionTypes from 'app_modules/network/constants'

export const adminUpdateEmail = accountType => ({
  type: actionTypes.ADMIN_UPDATE_EMAIL_SUCCESS,
  payload: accountType,
})

export default adminUpdateEmail
